// @flow

import React, { Component } from 'react';
import classnames from 'classnames';
import type { Props } from '.';
import PageHeader from '../../components/page-header';
import './search.scss';

class Search extends Component<Props> {
  constructor() {
    super();
    this.state = {
      advancedSearchIsOpen: false,
      workTitle: '',
      workTitleError: '',
      lastName: '',
      lastNameError: '',
      firstName: '',
      firstNameError: '',
      isValid: true,
    };
    this.toggleAdvancedSearch = this.toggleAdvancedSearch.bind(this);
    this.submitSearch = this.submitSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.clearValue = this.clearValue.bind(this);
  }

  toggleAdvancedSearch() {
    const { advancedSearchIsOpen } = this.state;
    this.setState({
      advancedSearchIsOpen: !advancedSearchIsOpen,
    });
  }

  valid() {
    const {
      workTitle,
      firstName,
      lastName,
    } = this.state;
    let isValid = true;
    let workTitleError = '';
    let lastNameError = '';
    let firstNameError = '';
    if (workTitle.length === 0 && lastName.length === 0) {
      if (firstName.length > 0) {
        lastNameError = 'Please enter a last name.';
        isValid = false;
      } else {
        workTitleError = 'Please enter a work title.';
        isValid = false;
      }
    }
    if (firstName.length > 0 && lastName.length === 0) {
      lastNameError = 'Please enter a last name.';
      isValid = false;
    }
    if (workTitle.length > 0 && workTitle.length < 3) {
      workTitleError = 'Please enter at least 3 charachers';
      isValid = false;
    }
    if (lastName.length > 0 && lastName.length < 3) {
      lastNameError = 'Please enter at least 3 charachers';
      isValid = false;
    }
    if (firstName.length > 0 && firstName.length < 3) {
      firstNameError = 'Please enter at least 3 charachers';
      isValid = false;
    }
    this.setState({
      workTitleError,
      lastNameError,
      firstNameError,
      isValid,
    });
    return isValid;
  }

  submitSearch(event) {
    event.nativeEvent.preventDefault();
    const { resetSearchPrams, updateSearchParam } = this.props;
    const {
      workTitle,
      lastName,
      firstName,
    } = this.state;
    if (this.valid()) {
      resetSearchPrams();
      updateSearchParam('workTitle', workTitle);
      updateSearchParam('lastName', lastName);
      updateSearchParam('firstName', firstName);
      window.location = '/#/searchworks';
    }
  }

  handleChange(e) {
    const {
      isValid,
    } = this.state;
    if (!isValid) {
      this.valid();
    }
    this.setState({
      [e.target.name]: e.target.value,
    });
  }

  clearValue(fieldName) {
    this.setState({
      [fieldName]: '',
    });
  }

  render() {
    const {
      advancedSearchIsOpen,
      workTitle,
      lastName,
      firstName,
      workTitleError,
      lastNameError,
      firstNameError,
    } = this.state;
    return (
      <section className="main-content search-page">
        <PageHeader
          title="Search works"
          subTitle="Please enter a work title or last name"
          backLinkTo="/#"
          backLinkText="Home"
          alignLeft
        />
        <form className="prs-form" onSubmit={this.submitSearch}>
          <div>
            <label htmlFor="workTitle">
              <button
                type="button"
                className={classnames(
                  'prs-form--cancel',
                  { show: workTitle.length > 0 },
                )}
                onClick={() => this.clearValue('workTitle')}
              />
              Work title
              <input
                maxLength="50"
                value={workTitle}
                onChange={this.handleChange}
                name="workTitle"
                id="workTitle"
                placeholder="Enter work title"
              />
            </label>
            <div className="prs-form--error">
              <p>
                {workTitleError}
              </p>
            </div>
          </div>
          <div>
            <label htmlFor="lastName">
              <button
                type="button"
                className={classnames(
                  'prs-form--cancel',
                  { show: lastName.length > 0 },
                )}
                onClick={() => this.clearValue('lastName')}
              />
              Last name
              <input
                maxLength="50"
                value={lastName}
                onChange={this.handleChange}
                name="lastName"
                id="lastName"
                placeholder="Enter last name"
              />
            </label>
            <div className="prs-form--error">
              <p>
                {lastNameError}
              </p>
            </div>
          </div>
          <button type="button" className="prs-form--advanced-search" onClick={this.toggleAdvancedSearch}>
            <div>More</div>
            <div className={classnames(
              'prs-icon',
              { 'prs-icon-chevron-circle-up': advancedSearchIsOpen },
              { 'prs-icon-chevron-circle-down': !advancedSearchIsOpen },
            )}
            />
          </button>
          {advancedSearchIsOpen && (
            <div>
              <label htmlFor="firstName">
                <button
                  type="button"
                  className={classnames(
                    'prs-form--cancel',
                    { show: firstName.length > 0 },
                  )}
                  onClick={() => this.clearValue('firstName')}
                />
                First name
                <input
                  maxLength="50"
                  value={firstName}
                  onChange={this.handleChange}
                  name="firstName"
                  id="firstName"
                  placeholder="Enter first name"
                />
              </label>
              <div className="prs-form--error">
                <p>
                  {firstNameError}
                </p>
              </div>
            </div>
          )}
          <div className="prs-form--submit">
            <button
              type="submit"
              className="btn btn-block btn-secondary"
            >
              Search
            </button>
          </div>
        </form>
      </section>
    );
  }
}

export default Search;
